import { ReadonlyRecord, IDictionary } from '@bimser/core';
import { Map, Record } from 'immutable';
import { Announcement, AnnouncementFactoryFromJS, IAnnouncement } from './IAnnouncement';
import {
	AnnouncementPanelsFactoryFromJS,
	IAnnouncementPanels,
	AnnouncementPanels,
	AnnouncementPanelsFactory
} from './IAnnouncementPanels';

interface IBaseAnnouncementState {
	listPanelGuid: string;
	formLoading: boolean;
}
export interface IAnnouncementState extends IBaseAnnouncementState {
	items: IDictionary<IAnnouncement>;
	startupItems: IDictionary<IAnnouncement>;
	panels: IAnnouncementPanels;
}

export interface IReadonlyAnnouncementState extends IBaseAnnouncementState {
	items: Map<string, Announcement>;
	startupItems: Map<string, Announcement>;
	panels: AnnouncementPanels;
}

export type AnnouncementState = ReadonlyRecord<IReadonlyAnnouncementState>;

export const AnnouncementStateFactory = Record<IReadonlyAnnouncementState>({
	items: Map<string, Announcement>(),
	startupItems: Map<string, Announcement>(),
	listPanelGuid: '',
	panels: AnnouncementPanelsFactory(),
	formLoading: false
});

export const AnnouncementStateFactoryFromJS = function (data: IAnnouncementState) {
	const _items: IDictionary<Announcement> = Object.keys(data.items).reduce(function (
		previous: IDictionary<Announcement>,
		current
	) {
		previous[current] = AnnouncementFactoryFromJS(data.items[current]);
		return previous;
	}, {});

	const _dashboardItems: IDictionary<Announcement> = Object.keys(data.items).reduce(function (
		previous: IDictionary<Announcement>,
		current
	) {
		previous[current] = AnnouncementFactoryFromJS(data.items[current]);
		return previous;
	}, {});

	return AnnouncementStateFactory({
		...data,
		items: Map(_items),
		startupItems: Map(_dashboardItems),
		panels: AnnouncementPanelsFactoryFromJS(data.panels)
	});
};
